<template>
  <div
    id="contact-details-form"
    class="pb-3"
    v-if="question && question.is_enabled && !isLoading"
  >
    <div class="question-title mb-3">{{ question.question }}</div>
    <div>
        <ImageRender
          v-if="question.image"
          :imgBase64="question.image" :showCloseButton="false"/>
    </div>
    <b-form>
      <b-row>
        <b-col
          v-for="(content, key) in question.contents"
          :key="key"
          :lg="halfWidthInput.includes(content.attributes.type) ? '6' : '12'"
        >
          <template v-if="content.visible">
            <!-- BIRTHDAY QUESTION TYPE START -->
            <b-form-group
              label-for="input-birthday"
              v-if="content.attributes.type === 'Birthday'"
            >
              <template slot="label" class="secondary-label">
                {{ content.attributes.label }}
                <sup
                  class="text-danger font-weight-bold"
                  v-if="content.required"
                >
                  *
                </sup>
              </template>
              <b-row>
                <b-col md="5" class="mb-3 mb-md-0">
                  <b-form-select v-model="selectedMonth" :value="null">
                    <option :value="null" disabled>Month</option>
                    <option
                      v-for="(month, index) in months"
                      :key="`month_${index}`"
                      :value="month"
                    >
                      {{ month }}
                    </option>
                  </b-form-select>
                </b-col>
                <b-col md="7">
                  <b-row>
                    <b-col md="6" class="mb-3 mb-md-0">
                      <b-form-select v-model="selectedDay" :value="null">
                        <option :value="null" disabled>Day</option>
                        <option
                          v-for="(day, index) in days"
                          :key="`day_${index}`"
                          :value="day"
                        >
                          {{ day }}
                        </option>
                      </b-form-select>
                    </b-col>
                    <b-col md="6">
                      <b-form-select v-model="selectedYear" :value="null">
                        <option :value="null" disabled>Year</option>
                        <option
                          v-for="(year, index) in years"
                          :key="`year_${index}`"
                          :value="year"
                        >
                          {{ year }}
                        </option>
                      </b-form-select>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <!-- HIDDEN INPUT FOR CORRECT ORDER OF ELEMENT START -->
              <b-input
                v-model="answers[content.attributes.type]"
                :value="
                  (answers[content.attributes.type] = answers[
                    content.attributes.type
                  ]
                    ? answers[content.attributes.type]
                    : '')
                "
                class="d-none"
              ></b-input>
              <!-- HIDDEN INPUT FOR CORRECT ORDER OF ELEMENT END -->
              <b-form-invalid-feedback
                :state="isInvalid(content.attributes.label)"
              >
                {{ errorMessage(content.attributes.label) }}
              </b-form-invalid-feedback>
            </b-form-group>
            <!-- BIRTHDAY QUESTION TYPE END -->
            <!-- ADDRESS QUESTION TYPE START -->
            <template v-else-if="content.attributes.type === 'Address'">
              <b-col class="px-0">
                <b-row>
                  <b-col
                    v-for="(option, key) in content.attributes.options.filter(
                      option => option.visible
                    )"
                    :key="key"
                    :lg="halfWidthInput.includes(option.type) ? '6' : '12'"
                  >
                    <b-form-group
                      :label-for="`input-${kebabCase(option.type)}`"
                    >
                      <template slot="label" class="secondary-label">
                        {{ option.label }}
                        <sup
                          class="text-danger font-weight-bold"
                          v-if="option.required"
                        >
                          *
                        </sup>
                      </template>
                      <!-- ZIP CODE START -->
                      <template v-if="option.type === 'Zip Code'">
                        <b-input
                          :id="`input-${kebabCase(option.type)}`"
                          type="text"
                          :placeholder="option.placeholder"
                          :maxlength="maxInputLength[option.type]"
                          @keypress.native="filterAlphaNumeric"
                          v-model="answers[option.label]"
                          :value="
                            (answers[option.label] = answers[option.label]
                              ? answers[option.label]
                              : '')
                          "
                        ></b-input>
                      </template>
                      <!-- ZIP CODE END -->
                      <!-- CITY START -->
                      <template v-else-if="option.type === 'City'">
                        <template v-if="option.input_type === 'textbox'">
                          <b-input
                            :id="`input-${kebabCase(option.type)}`"
                            type="text"
                            :placeholder="option.placeholder"
                            :maxlength="maxInputLength[option.type]"
                            @keypress.native="filterAlpha"
                            v-model="answers[option.label]"
                            :value="
                              (answers[option.label] = answers[option.label]
                                ? answers[option.label]
                                : '')
                            "
                          ></b-input>
                        </template>
                        <template v-else-if="option.input_type === 'ALL'">
                          <b-form-select
                            v-model="answers[option.label]"
                            :value="
                              (answers[option.label] = answers[option.label]
                                ? answers[option.label]
                                : '')
                            "
                          >
                            <option disabled :value="''">
                              {{ option.placeholder }}
                            </option>
                            <option
                              v-for="(city, key) in cities"
                              :key="key"
                              :value="city.name"
                            >
                              {{ city.name }}
                            </option>
                          </b-form-select>
                        </template>
                        <template v-else>
                          <b-form-select
                            v-model="answers[option.label]"
                            :value="
                              (answers[option.label] = answers[option.label]
                                ? answers[option.label]
                                : '')
                            "
                          >
                            <option disabled :value="''">
                              {{ option.placeholder }}
                            </option>
                            <option
                              v-for="(city, key) in ncrCities"
                              :key="key"
                              :value="city.name"
                            >
                              {{ city.name }}
                            </option>
                          </b-form-select>
                        </template>
                      </template>
                      <!-- CITY END -->
                      <!-- PROVINCE START -->
                      <template v-else-if="option.type === 'Province'">
                        <template v-if="option.input_type === 'textbox'">
                          <b-input
                            :id="`input-${kebabCase(option.type)}`"
                            type="text"
                            :placeholder="option.placeholder"
                            :maxlength="maxInputLength[option.type]"
                            @keypress.native="filterAlpha"
                            v-model="answers[option.label]"
                            :value="
                              (answers[option.label] = answers[option.label]
                                ? answers[option.label]
                                : '')
                            "
                          ></b-input>
                        </template>
                        <template v-else>
                          <b-form-select
                            v-model="answers[option.label]"
                            :value="
                              (answers[option.label] = answers[option.label]
                                ? answers[option.label]
                                : '')
                            "
                          >
                            <option disabled :value="''">
                              {{ option.placeholder }}
                            </option>
                            <option
                              v-for="(province, key) in provinces"
                              :key="key"
                              :value="province.name"
                            >
                              {{ province.name }}
                            </option>
                          </b-form-select>
                        </template>
                      </template>
                      <!-- PROVINCE END -->
                      <!-- ADDRESS 1 & 2 START -->
                      <template v-else>
                        <b-input
                          :id="`input-${kebabCase(option.type)}`"
                          type="text"
                          :placeholder="option.placeholder"
                          :maxlength="maxInputLength[option.type]"
                          @keypress.native="filterAlphaNumericPunctuations"
                          v-model="answers[option.label]"
                          :value="
                            (answers[option.label] = answers[option.label]
                              ? answers[option.label]
                              : '')
                          "
                        >
                        </b-input>
                      </template>
                      <!-- ADDRESS 1 & 2 END -->
                      <b-form-invalid-feedback :state="isInvalid(option.label)">
                        {{ errorMessage(option.label) }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
            </template>
            <!-- ADDRESS TYPES END -->
            <!-- EMAIL ADDRESS START -->
            <template v-else-if="content.attributes.type === 'Email Address'">
              <b-form-group
                :label-for="`input-${kebabCase(content.attributes.type)}`"
              >
                <template slot="label" class="secondary-label">
                  {{ content.attributes.label }}
                  <sup
                    class="text-danger font-weight-bold"
                    v-if="content.required"
                  >
                    *
                  </sup>
                </template>
                <b-input
                  :id="`input-${kebabCase(content.attributes.type)}`"
                  type="email"
                  :placeholder="content.attributes.placeholder"
                  :maxlength="maxInputLength[content.attributes.type]"
                  v-model="answers[content.attributes.label]"
                  :value="
                    (answers[content.attributes.label] = answers[
                      content.attributes.label
                    ]
                      ? answers[content.attributes.label]
                      : '')
                  "
                >
                </b-input>
                <b-form-invalid-feedback
                  :state="isInvalid(content.attributes.label)"
                >
                  {{ errorMessage(content.attributes.label) }}
                </b-form-invalid-feedback>
              </b-form-group>
            </template>
            <!-- EMAIL ADDRESS END -->
            <!-- CONTACT NUMBER START -->
            <template v-else-if="content.attributes.type === 'Contact No.'">
              <b-form-group
                :label-for="`input-${kebabCase(content.attributes.type)}`"
              >
                <template slot="label" class="secondary-label">
                  {{ content.attributes.label }}
                  <sup
                    class="text-danger font-weight-bold"
                    v-if="content.required"
                  >
                    *
                  </sup>
                </template>
                <b-input
                  :id="`input-${kebabCase(content.attributes.type)}`"
                  type="text"
                  :placeholder="content.attributes.placeholder"
                  :maxlength="maxInputLength[content.attributes.type]"
                  @keypress.native="filterNumeric"
                  v-model="answers[content.attributes.label]"
                  :value="
                    (answers[content.attributes.label] = answers[
                      content.attributes.label
                    ]
                      ? answers[content.attributes.label]
                      : '')
                  "
                >
                </b-input>
                <b-form-invalid-feedback
                  :state="isInvalid(content.attributes.label)"
                >
                  {{ errorMessage(content.attributes.label) }}
                </b-form-invalid-feedback>
              </b-form-group>
            </template>
            <!-- CONTACT NUMBER END -->
            <!-- CIVIL STATUS START -->
            <template v-else-if="content.attributes.type === 'Civil Status'">
              <b-form-group
                :label-for="`input-${kebabCase(content.attributes.type)}`"
              >
                <template slot="label" class="secondary-label">
                  {{ content.attributes.label }}
                  <sup
                    class="text-danger font-weight-bold"
                    v-if="content.required"
                  >
                    *
                  </sup>
                </template>
                <b-form-select v-model="answers[content.attributes.label]">
                  <option :value="null" disabled>Civil Status</option>
                  <option
                    v-for="(civilStatusOption, index) in civilStatusOptions"
                    :key="`civilStatusOption_${index}`"
                    :value="civilStatusOption.value"
                  >
                    {{ civilStatusOption.text }}
                  </option>
                </b-form-select>
                <b-form-invalid-feedback
                  :state="isInvalid(content.attributes.label)"
                >
                  {{ errorMessage(content.attributes.label) }}
                </b-form-invalid-feedback>
              </b-form-group>
            </template>
            <!-- CIVIL STATUS END -->
            <!-- GENDER START -->
            <template v-else-if="content.attributes.type === 'Gender'">
              <b-form-group
                :label-for="`input-${kebabCase(content.attributes.type)}`"
              >
                <template slot="label" class="secondary-label">
                  {{ content.attributes.label }}
                  <sup
                    class="text-danger font-weight-bold"
                    v-if="content.required"
                  >
                    *
                  </sup>
                </template>
                <b-form-select v-model="answers[content.attributes.label]">
                  <option :value="null" disabled>Gender</option>
                  <option
                    v-for="(genderOption, index) in genderOptions"
                    :key="`genderOption_${index}`"
                    :value="genderOption.value"
                  >
                    {{ genderOption.text }}
                  </option>
                </b-form-select>
                <b-form-invalid-feedback
                  :state="isInvalid(content.attributes.label)"
                >
                  {{ errorMessage(content.attributes.label) }}
                </b-form-invalid-feedback>
              </b-form-group>
            </template>
            <!-- GENDER END -->
            <!-- PARENTHOOD START -->
            <template v-else-if="content.attributes.type === 'Parenthood'">
              <b-form-group
                :label-for="`input-${kebabCase(content.attributes.type)}`"
              >
                <template slot="label" class="secondary-label">
                  {{ content.attributes.label }}
                  <sup
                    class="text-danger font-weight-bold"
                    v-if="content.required"
                  >
                    *
                  </sup>
                </template>
                <b-form-select v-model="answers[content.attributes.label]">
                  <option :value="null" disabled>Parenthood</option>
                  <option
                    v-for="(parenthoodOption, index) in parenthoodOptions"
                    :key="`parenthoodOption_${index}`"
                    :value="parenthoodOption.value"
                  >
                    {{ parenthoodOption.text }}
                  </option>
                </b-form-select>
                <b-form-invalid-feedback
                  :state="isInvalid(content.attributes.label)"
                >
                  {{ errorMessage(content.attributes.label) }}
                </b-form-invalid-feedback>
              </b-form-group>
            </template>
            <!-- PARENTHOOD END -->
            <!-- CUSTOM FIELDS START -->
            <template v-else-if="content.attributes.type === 'Custom Fields'">
              <b-form-group
                :label-for="`input-${kebabCase(content.attributes.type)}`"
              >
                <template slot="label" class="secondary-label">
                  {{ content.attributes.label }}
                  <sup
                    class="text-danger font-weight-bold"
                    v-if="content.required"
                  >
                    *
                  </sup>
                </template>
                <b-input
                  :id="`input-${kebabCase(content.attributes.type)}`"
                  type="text"
                  :placeholder="content.attributes.placeholder"
                  :maxlength="maxInputLength[content.attributes.type]"
                  @keypress.native="filterAlphaNumericPunctuations"
                  v-model="answers[content.attributes.label]"
                  :value="
                    (answers[content.attributes.label] = answers[
                      content.attributes.label
                    ]
                      ? answers[content.attributes.label]
                      : '')
                  "
                >
                </b-input>
                <b-form-invalid-feedback
                  :state="isInvalid(content.attributes.label)"
                >
                  {{ errorMessage(content.attributes.label) }}
                </b-form-invalid-feedback>
              </b-form-group>
            </template>
            <!-- CUSTOM FIELDS END -->
            <!-- NAME (FIRST, LAST, FULL) START -->
            <template v-else>
              <b-form-group
                :label-for="`input-${kebabCase(content.attributes.type)}`"
              >
                <template slot="label" class="secondary-label">
                  {{ content.attributes.label }}
                  <sup
                    class="text-danger font-weight-bold"
                    v-if="content.required"
                  >
                    *
                  </sup>
                </template>
                <b-input
                  :id="`input-${kebabCase(content.attributes.type)}`"
                  type="text"
                  :placeholder="content.attributes.placeholder"
                  :maxlength="maxInputLength[content.attributes.type]"
                  @keypress.native="filterAlphaNumeric"
                  v-model="answers[content.attributes.label]"
                  :value="
                    (answers[content.attributes.label] = answers[
                      content.attributes.label
                    ]
                      ? answers[content.attributes.label]
                      : '')
                  "
                >
                </b-input>
                <b-form-invalid-feedback
                  :state="isInvalid(content.attributes.label)"
                >
                  {{ errorMessage(content.attributes.label) }}
                </b-form-invalid-feedback>
              </b-form-group>
            </template>
            <!-- NAME (FIRST, LAST, FULL) END -->
          </template>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import { kebabCase } from "lodash";
import { mapGetters, mapActions } from "vuex";
import ImageRender from "../../../components/ImageRender.vue";
export default {
  name: "ContactDetails",
  components: {
    ImageRender,
  },
  data() {
    return {
      maxInputLength: {
        "Full Name": 100,
        "First Name": 50,
        "Last Name": 50,
        "Email Address": 100,
        "Contact No.": 11,
        "Address 1": 100,
        "Address 2": 100,
        City: 30,
        Province: 30,
        "Zip Code": 15,
        "Custom Fields": 100,
        "Civil Status": 20
      },
      halfWidthInput: [
      ],
      selectedMonth: null,
      selectedDay: null,
      selectedYear: null
    };
  },
  props: ["question", "answers"],
  computed: {
    ...mapGetters("survey", ["errors", "isLoading"]),
    ...mapGetters("location", ["cities", "ncrCities", "provinces"]),
    months() {
      const months = [];
      for (var month = 1; month < 13; month++) {
        months.push(month < 10 ? `0${month}` : month);
      }
      return months;
    },
    days() {
      const days = [];
      for (var day = 1; day < 32; day++) {
        days.push(day < 10 ? `0${day}` : day);
      }
      return days;
    },
    years() {
      const years = [];
      let year = 1900;
      while (year < new Date().getFullYear()) {
        years.push(year);
        year++;
      }
      return years;
    },
    civilStatusOptions() {
      const civilStatusOptions = [
        { value: "Single", text: "Single" },
        { value: "Married", text: "Married" },
        { value: "Separated", text: "Separated" },
        { value: "Widow/Widower", text: "Widow/Widower" }
      ];
      return civilStatusOptions;
    },
    genderOptions() {
      const genderOptions = [
        { value: "M", text: "Male" },
        { value: "F", text: "Female" },
        { value: "NA", text: "Prefer not to say" }
      ];
      return genderOptions;
    },
    parenthoodOptions() {
      const parenthoodOptions = [
        { value: "Parent", text: "Parent" },
        { value: "Non-parent", text: "Non-parent" }
      ];
      return parenthoodOptions;
    }
  },
  methods: {
    ...mapActions("location", ["getCities", "getNCRCities", "getProvinces"]),
    kebabCase(text) {
      return kebabCase(text);
    },
    isNotAlphaNumericPunctuations(input) {
      return /[^A-Za-z0-9,.!?'":()\s\-]+/g.test(input); //eslint-disable-line
    },
    filterAlphaNumericPunctuations(e) {
      if (this.isNotAlphaNumericPunctuations(String.fromCharCode(e.keyCode)))
        e.preventDefault();
    },
    isNotAlphaNumeric(input) {
      return /[^A-Za-z0-9\s]+/g.test(input); //eslint-disable-line
    },
    filterAlphaNumeric(e) {
      if (this.isNotAlphaNumeric(String.fromCharCode(e.keyCode)))
        e.preventDefault();
    },
    isNotAlpha(input) {
      return /[^A-Za-z\s]+/g.test(input); //eslint-disable-line
    },
    filterAlpha(e) {
      if (this.isNotAlpha(String.fromCharCode(e.keyCode))) e.preventDefault();
    },
    isNotNumeric(input) {
      return /[^0-9]+/g.test(input); //eslint-disable-line
    },
    filterNumeric(e) {
      if (this.isNotNumeric(String.fromCharCode(e.keyCode))) e.preventDefault();
    },
    isInvalid(field) {
      if (this.errors === null) {
        return null;
      } else {
        return !Object.keys(this.errors).includes(field)
          ? null
          : !Object.keys(this.errors).includes(field);
      }
    },
    errorMessage(field) {
      if (this.errors === null) {
        return "";
      } else if (Object.keys(this.errors).includes(field)) {
        return Array.isArray(this.errors[field])
          ? this.errors[field].join(" ")
          : this.errors[field];
      }
    },
    setBirthday() {
      if (this.selectedMonth && this.selectedDay && this.selectedYear) {
        this.answers[
          "Birthday"
        ] = `${this.selectedYear}-${this.selectedMonth}-${this.selectedDay}`;
      }
    }
  },
  watch: {
    selectedMonth() {
      this.setBirthday();
    },
    selectedDay() {
      this.setBirthday();
    },
    selectedYear() {
      this.setBirthday();
    }
  },
  created() {
    this.getCities();
    this.getNCRCities();
    this.getProvinces();

    if (this.answers["Birthday"]) {
      const birthday = this.answers["Birthday"].split("-");

      this.selectedMonth = birthday[0];
      this.selectedDay = birthday[1];
      this.selectedYear = birthday[2];
    }
  }
};
</script>

<style></style>
